import { isFaw } from '../config/branding';

// Status mappings for breakdown mechanic status
export const BREAKDOWN_MECHANIC_STATUS = {
  0: 'Accepted',
  1: 'Rejected',
  2: 'Pending',
  3: 'No Response',
  4: 'Released',
  5: 'Remove'
};

// Status colors for the badges
export const BREAKDOWN_STATUS_COLORS = {
  0: '#52c41a', // green for Accepted
  1: '#f5222d', // red for Rejected
  2: '#faad14', // orange for Pending
  3: '#1677ff', // blue for No Response
  4: '#722ed1', // purple for Released
  5: '#bfbfbf'  // grey for Remove
};

// Call Me statuses
export const CALL_ME_STATUS = {
  0: 'Opened',
  1: 'InProgress',
  2: 'Closed',
  3: 'Cancelled',
  4: 'Resolved'
};

// Panic statuses
export const PANIC_STATUS = {
  0: 'Open',
  1: 'InProgress',
  2: 'Closed',
  3: 'Cancelled',
  4: 'Resolved'
};

// Vehicle related constants
export const VEHICLE_TYPES = {
  CAR: 'Car',
  TRUCK: 'Truck',
  VAN: 'Van',
  OTHER: 'Other'
};

// API URLs configuration
// Use environment variables with fallback for backward compatibility
const isLocalFaw = window.location.hostname.toLowerCase() === 'faw.localhost';
const FAW_API_URL = 'https://v2-pretty-faw-api-bebna5bberfwaghq.southafricanorth-01.azurewebsites.net/api';

export const API_CONFIG = {
  BASE_URL: isFaw
    ? isLocalFaw
      ? import.meta.env.VITE_APP_API_URL || 'https://localhost:7091/api'
      : FAW_API_URL
    : import.meta.env.VITE_APP_API_URL || 'https://localhost:7091/api',
  ENVIRONMENT: import.meta.env.VITE_APP_ENV || 'development',
  AUTH: {
    LOGIN: isFaw ? '/Auth/faw/performlogin' : '/Auth/performlogin'
  },
  USER: {
    SET_ON_DUTY: '/V2User/SetOnDuty',
    GET_ON_DUTY: '/V2User/GetOnDuty',
    SET_LOCATION: '/V2User/SetLocation',
    SET_OLD_USER_LOCATION: '/User/SetUserLocation'
  },
  BREAKDOWNS: {
    GET_FULL_DETAIL: '/mobile/Breakdowns/getfullbreakdowndetail',
    INSERT_NOTES: '/Breakdowns/insertbreakdownnotes',
    INSERT_NOTES_REALTIME: '/Events/Breakdowns/note-notification-hub',
    ADD_IMAGE: '/Breakdowns/AddBreakdownImage',
    GET_ALL: '/mobile/Breakdowns/getallbreakdowns',
    GET_MECHANICS: '/Breakdowns/getbreakdownmechanics',
    GET_IMAGE_IDS: '/Breakdowns/RetrieveBreakdownImageIdList',
    GET_IMAGE: '/Breakdowns/RetrieveBreakdownImageDynamically',
    GET_STATUSES: '/BreakdownStatus/getbreakdownstatuses',
    GET_MECHANIC_STATUSES: '/Breakdowns/GetMechanicStatuses',
    GET_MECHANIC_DETAILS: '/Breakdowns/getMechanicDetails',
    UPDATE_MECHANIC_STATUS: '/Breakdowns/updateMechanicStatuses',
    ACCEPT_MECHANIC_STATUS: '/RepairActions/repairmechanicaccept',
    GET_HISTORY: '/Breakdowns/getBreakdownHistory',
    HISTORY_DASHBOARD_LIST: '/Breakdowns/HistoryBreakdownDashboardList',
    CREATE_REQUEST: '/Breakdowns/CreateBreakdownRequest2',
    ASSIGN_MECHANIC: '/Breakdowns/AsignMechanicAndSupplier',
    UPDATE_STATUS: '/Breakdowns/UpdateBreakdownStatus',
    UPDATE_STATUS_REALTIME: '/Events/Breakdowns/status-notification-hub',
    ADD_REQUEST_IMAGE: '/BreakdownFileUpload/AddBreakdownRequestImage'
  },
  EVENTS: {
    CREATE: '/Events/Breakdowns/UpdateAndCreateBreakdown',
    ACTIVE_LIST: '/Events/Breakdowns/ActiveEventsList',
    LOOKUPS: '/Events/Breakdowns/event-lookups',
    GET_FULL_DETAIL: '/Events/Breakdowns/V2GetFullBreakdownDetail',
    GET_STATUSES: '/Events/Breakdowns/GetEventStatuses',
    GET_CURRENT_STATUS: '/Events/Breakdowns/GetCurrentEventStatus',
    UPDATE_STATUS: '/Events/Breakdowns/UpdateBreakdownStatus',
    GET_MECHANIC_DETAILS: '/Events/Breakdowns/getMechanicDetails',
    GET_COMPANY_ASSIGNED_MECHANICS: '/Events/BreakdownMechanics/GetCompanyMechanicsAssigned',
    ASSIGN_MECHANIC: '/Events/Breakdowns/AsignMechanicAndSupplier',
    CANCELLATION_REASONS: '/Events/Breakdowns/CancellationReasons',
    GET_HISTORY: '/Events/Breakdowns/getBreakdownHistory',
    FULL_RESOLVE: '/Events/Breakdowns/FullResolve',
    INSERT_CHANGE_LOG: '/Events/Breakdowns/InsertBreakdownChangeLog',
    GET_BREAKDOWN_BY_ID: '/Events/Breakdowns/getBreakdownById',
    GET_CUSTOM_FIELDS: '/Events/Breakdowns/custom-fields',
    CUSTOM_FIELD_VALUES: '/Events/Breakdowns/custom-field-values',
    ADD_IMAGE: '/Events/Breakdowns/AddBreakdownImage',
    GET_IMAGE_IDS: '/Events/Breakdowns/RetrieveBreakdownImageIdList',
    GET_IMAGE: '/Events/Breakdowns/RetrieveBreakdownImageDynamically',
    GET_ALL_IMAGES: '/Events/Breakdowns/RetrieveAllBreakdownImages',
    GET_MEDIA_URLS: '/Events/Breakdowns/V2RetrieveAllBreakdownMediaUrls',
    NOTE_NOTIFICATION: '/Events/Breakdowns/note-notification-hub',
    STATUS_NOTIFICATION: '/Events/Breakdowns/status-notification-hub'
  },
  SUPPLIER: {
    UPDATE_BREAKDOWN_MECHANIC: '/Supplier/UpdateBreakdownMechanic',
    GET_FINANCE_CURRENCIES: '/Supplier/GetAllFinanceCurrencies'
  },
  OEM: {
    GET_ALL: '/OEM/GetAllOem'
  },
  COMPANY: {
    GET_COMPANY_LIST: '/company/GetCompanyList/0',
    GET_MECHANIC_LIST: '/Company/GetMechanicList'
  },
  DRIVERS: {
    GET_COMPANY_DRIVERS: '/drivers/getdrivers/getcompanydrivers'
  },
  VEHICLES: {
    SEARCH_VEHICLE: '/Vehicles/SearchVehicle',
    GET_COMPANY_VEHICLES: '/Vehicles/getvehiclesbycompany'
  },
  TELEMATICS: {
    GET_VEHICLE_LOCATION: '/V2Telematics/GetVehicleLocation'
  },
  LOCATIONS: {
    GET_ALL_CUSTOM_LOCATIONS: '/CustomLocation/GetAllCustomLocations'
  },
  REPAIR_ACTIONS: {
    GET_BREAKDOWN_CATEGORIES: '/RepairActions/getbreakdowncategories',
    GET_BREAKDOWN_SUBCATEGORIES: '/RepairActions/getbreakdownsubcategories',
    GET_BREAKDOWN_CAUSES: '/BreakdownCauses/getallactive',
    FINISH_BREAKDOWN: '/RepairActions/FinishBreakdown'
  },
  INSPECTIONS: {
    // Vehicle endpoints
    GET_VEHICLE_BY_COMPANY: '/VehicleList/getvehiclesbycompanyid',
    GET_COMPANY_VEHICLES: '/V2Inspections/companyvehicles',
    GET_TRUCK_BY_REG: '/V2Inspections/truckbyreg',

    // Fleet endpoints
    GET_COMPANY_FLEETS: '/V2Inspections/companyfleets',
    GET_COMPANY_FLEET_TRUCKS: '/V2Inspections/companyfleettrucks',

    // Template endpoints
    GET_TEMPLATE_COMPANIES: '/V2Inspections/templatecompanies',
    GET_TEMPLATES: '/V2Inspections/templates',
    GET_TEMPLATE: '/V2Inspections/templates',

    // Response endpoints
    RESPONSES: '/V2Inspections/responses',
    UPLOAD_RESPONSE_IMAGES: '/V2Inspections/responses', // POST /responses/{id}/images
    GET_MY_RESPONSES: '/V2Inspections/responses/mine',
    DELETE_RESPONSE_IMAGE: '/V2Inspections/deleteresponseimage',

    // History endpoints
    GET_HISTORY: '/V2Inspections/responses',

    //Request Details
    GET_INSPECTION_REQUEST_DETAILS: '/V2Inspections/RequestDetails',

    // Accident Report
    GET_ACCIDENT_REPORT: '/V2Inspections/accidentReport',
    GET_ACCIDENT_REPORT_RESPONSES: '/V2Inspections/accidentReportResponses',
    GET_INSPECTION_TO_PDF: '/V2Inspections/PdfToBlob'
  },
  BREAKDOWN_REQUESTS: {
    GET_ACTIVE: '/breakdownrequests/BreakdownRequest/GetActiveRequests',
    POST_BREAKDOWN_REQUEST: '/Breakdowns/CreateBreakdownRequestFromInspection'
  },
  BREAKDOWN_MECHANICS: {
    GET_ASSIGNED: '/BreakdownMechanics/GetCompanyMechanicsAssigned'
  },
  NOTIFICATIONS: {
    POST_FCM_TOKEN: '/Notification/Register',
    POST_CHECK_TOKEN: '/Notification/CheckUserPushToken'
  },
  PANICS: {
    CREATE_CALL_ME: '/Panics/CreateCallMe',
    GET_CALL_ME_BY_ID: '/Panics/GetCallMeById',
    CREATE_PANIC: '/Panics/CreatePanic',
    GET_PANIC_BY_ID: '/Panics/GetPanicById'
  },
  SSE: {
    BREAKDOWNS_STREAM: '/BreakdownMechanics/breakdownsStream'
  },
  GOOGLEGEOCODE: {
    GEOCODE: '/V2Geocode/Geocode',
    GEOCODE_BY_PLACE_ID: '/V2Geocode/GeocodeByPlaceId',
    REVERSE_GEOCODE: '/V2Geocode/ReverseGeocode',
    AUTOCOMPLETE: '/V2Geocode/Autocomplete'
  },
  ACCESS: {
    ME: '/V2Access/me'
  },
  DOCUMENTS: {
    BASE: '/V2Documents',
    INSPECTIONS: '/V2Documents/inspections',
    AVAILABLE_TEMPLATES: '/V2Documents/available-templates',
    TEMPLATE_COMPANIES: '/V2Documents/templates',
    TEMPLATE_FIELDS: '/V2CompanyDocumentTemplates/templates',
    WORD: '/V2DocumentWord',
    CURRENCIES: '/Supplier/GetAllFinanceCurrencies',
    COMPANY_FLEETS: '/V2Inspections/companyfleets'
  }
};

// HereMaps API configuration
export const HERE_MAPS_CONFIG = {
  API_KEY: import.meta.env.VITE_HERE_MAPS_API_KEY || 'your-here-maps-api-key',
  GEOCODE_URL: 'https://geocode.search.hereapi.com/v1/geocode',
  REVERSE_GEOCODE_URL: 'https://revgeocode.search.hereapi.com/v1/revgeocode'
};

// API Endpoints for external services
export const API_ENDPOINTS = {
  geocode: HERE_MAPS_CONFIG.GEOCODE_URL,
  revgeocode: HERE_MAPS_CONFIG.REVERSE_GEOCODE_URL
};

// HereMaps API Key (for backward compatibility)
export const HERE_MAPS_API_KEY = HERE_MAPS_CONFIG.API_KEY;

// App configuration
export const APP_CONFIG = {
  TOKEN_REFRESH_INTERVAL: 5 * 60 * 1000, // 5 minutes in milliseconds
  BREAKDOWN_REFRESH_INTERVAL: 60 * 1000, // 1 minute in milliseconds
  API_URL: API_CONFIG.BASE_URL, // Legacy reference for backward compatibility
  CALL_NUMBER: '+27316300191', // Call Center Number
  CALL_ME_REFRESH_INTERVAL: 30 * 1000, // 30 seconds
  PANIC_REFRESH_INTERVAL: 30 * 1000, // 30 seconds
  USE_SSE: false // Feature flag: enable/disable SSE real-time updates
};
